var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _g2, _rect, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSequoiaCapital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 548.5 102.7",
    style: {
      enableBackground: "new 0 0 548.5 102.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1228f3;}\n\t.st1{fill:#1228f3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.1,39.4l-3.8-6.6c1.8-3.4,1.8-7.4,1.8-12.6c0-6.6,0.1-11.5-3.8-15.3c-2.7-2.7-6-4.2-10.4-4.2 s-7.7,1.5-10.4,4.2c-3.9,3.9-3.8,8.7-3.8,15.3s-0.1,11.4,3.8,15.3c2.7,2.7,6.1,4.2,10.4,4.2c1.2,0,2.2-0.1,3.3-0.3L105.1,39.4 L105.1,39.4z M84,31c-1.5-1.6-1.8-3.4-1.8-10.8S82.5,11,84,9.4c1.1-1.2,2.8-2,4.9-2c2.1,0,3.7,0.8,4.8,2c1.5,1.6,1.9,3.4,1.9,10.8 s-0.4,9.2-1.9,10.8c-1.1,1.2-2.8,2.1-4.8,2.1S85,32.2,84,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.9,39.4V1h7.4v38.4H192.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,39.8c-5.8,0-10.3-1.2-14-5.1L5,29.8c2.4,2.4,5.7,3.2,9.3,3.2c4.4,0,6.8-1.7,6.8-4.8 c0-1.3-0.4-2.5-1.2-3.2c-0.8-0.7-1.6-1.1-3.4-1.3l-4.6-0.7c-3.3-0.5-5.7-1.5-7.5-3.2c-1.8-1.8-2.8-4.3-2.8-7.6 c0-6.9,5.1-11.7,13.4-11.7c5.3,0,9.1,1.3,12.4,4.5l-4.8,4.7c-2.4-2.3-5.3-2.7-7.9-2.7c-4,0-5.9,2.2-5.9,4.9c0,1,0.3,2,1.1,2.8 c0.8,0.7,2,1.3,3.6,1.5l4.5,0.7c3.5,0.5,5.7,1.5,7.3,3c2,1.9,3,4.8,3,8.1C28.5,35.5,22.3,39.7,14.2,39.8L14.2,39.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,39.4V1h25.3v6.7H47v9h15.2v6.7H47v9.3h17.8v6.7L39.5,39.4L39.5,39.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,39.8c-7.9,0-14.1-5.3-14.1-13.5V1h7.5v25c0,4.4,2.6,7.1,6.6,7.1s6.7-2.7,6.7-7.1V1h7.4v25.3 C142.7,34.4,136.4,39.8,128.5,39.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.1,35.5c-2.7,2.7-6,4.2-10.4,4.2s-7.7-1.5-10.4-4.2c-3.9-3.9-3.8-8.7-3.8-15.3s-0.1-11.5,3.8-15.3 c2.7-2.7,6.1-4.2,10.4-4.2s7.7,1.5,10.4,4.2c3.9,3.9,3.8,8.7,3.8,15.3S182,31.7,178.1,35.5z M172.5,9.4c-1.1-1.2-2.8-2-4.8-2 s-3.8,0.8-4.9,2c-1.5,1.6-1.8,3.4-1.8,10.8s0.4,9.2,1.8,10.8c1.1,1.2,2.8,2.1,4.9,2.1s3.7-0.8,4.8-2.1c1.5-1.6,1.9-3.4,1.9-10.8 S174,11,172.5,9.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.7,39.4l-2.3-6.8h-13.7l-2.3,6.8h-7.8l14-38.5h5.9l14,38.5H235.7L235.7,39.4z M226.7,12.3l-4.9,14h9.6 L226.7,12.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.8,7.7v31.8h-7.5V7.7h-10V1h30.1L425,7.7H414.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.7,39.8c-4.2,0-7.7-1.5-10.4-4.2c-3.9-3.9-3.8-8.7-3.8-15.3s-0.1-11.5,3.8-15.3c2.7-2.7,6.2-4.2,10.4-4.2 c7.2,0,12.8,4.1,14.1,12.2h-7.6c-0.8-3.1-2.7-5.5-6.5-5.5c-2,0-3.7,0.8-4.8,2c-1.5,1.6-1.9,3.5-1.9,10.9s0.4,9.2,1.9,10.8 c1.1,1.2,2.8,2,4.8,2c3.8,0,5.7-2.4,6.5-5.4h7.6C293.5,35.7,287.8,39.8,280.7,39.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.6,39.5l-2.3-6.8h-13.7l-2.3,6.8h-7.8l14-38.5h5.9l14,38.5H326.6L326.6,39.5z M317.7,12.4l-4.9,14h9.6 L317.7,12.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.6,25h-7.4v14.5h-7.5V1h14.9c7.9,0,12.7,5.5,12.7,12S365.5,25,357.6,25L357.6,25z M357.2,7.7h-7v10.5h7 c3.4,0,5.6-2.1,5.6-5.2S360.6,7.7,357.2,7.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.7,39.4V1h7.5v38.5H379.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.9,39.4l-2.3-6.8h-13.7l-2.3,6.8h-7.8l14-38.5h5.9l14,38.5H452.9L452.9,39.4z M443.9,12.3l-4.9,14h9.6 L443.9,12.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.4,39.4V1h7.5v31.7h17.4v6.7C494.3,39.4,469.4,39.4,469.4,39.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 538.4,
    y: 1,
    className: "st1",
    width: 9.6,
    height: 9.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.3,31.2 514.3,1 509.5,1 509.5,36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "517.7,34.6 512.9,39.4 548,39.4 548,34.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "523.9,21.6 523.9,1 519.1,1 519.1,26.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "527.3,25 522.5,29.8 548,29.8 548,25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "533.6,12 533.6,1 528.8,1 528.8,16.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "537,15.4 532.2,20.2 548,20.2 548,15.4  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180,79.1v-0.2c0-8,5-13.5,11.6-13.5c3.6,0,6,1.3,8,3.2l-1.7,2.2c-1.7-1.6-3.7-2.8-6.3-2.8 c-4.9,0-8.6,4.4-8.6,10.8v0.2c0,6.5,3.7,10.9,8.6,10.9c2.7,0,4.6-1.1,6.5-2.9l1.7,2c-2.2,2.2-4.8,3.6-8.4,3.6 C184.9,92.5,180,87.1,180,79.1L180,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.5,65.7h2.8v11.8h12.8V65.7h2.8v26.4h-2.8v-12h-12.8v12h-2.8C206.5,92.1,206.5,65.7,206.5,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.6,65.7h2.8v26.4h-2.8C234.6,92.1,234.6,65.7,234.6,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.2,65.7h2.7l13.8,20.8V65.7h2.8v26.4h-2.4l-14.2-21.3v21.3h-2.8L247.2,65.7L247.2,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.3,65.6h2.8l10.1,26.6h-3l-2.6-6.9h-11.9l-2.6,6.9h-2.9L282.3,65.6L282.3,65.6z M288.6,82.6l-5-13.4 l-5,13.4H288.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 55.8,
    className: "st0",
    width: 1.8,
    height: 46.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.1,68.9V85h-2.4v-2H90.4v11.4H88V83H77.7v2.2h-2.3V68.9H88v-6.2h2.4v6.2L103.1,68.9L103.1,68.9z M88,80.7 v-9.5H77.7v9.5H88z M100.8,80.7v-9.5H90.4v9.5H100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.3,64.3v30.2h-2.4v-1.8h-23.8v1.8h-2.3V64.3L139.3,64.3L139.3,64.3z M136.9,90.5V66.5h-23.8v24.1H136.9z  M134.7,85.1v2h-19.2v-2h8.2V79h-6.7v-2h6.7v-5.3h-7.7v-2.1H134v2.1h-8.1v5.3h7.2v2h-7.2v6.2H134.7z M129.8,79.7 c1.3,1.2,2.9,2.8,3.6,3.9l-1.6,0.9c-0.7-1.1-2.2-2.8-3.6-4L129.8,79.7L129.8,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,81.1c0,0.6,0,1.5,0.1,2c-9.6,1.5-10.8,1.8-11.6,2.2c-0.1-0.5-0.5-1.6-0.8-2.3c0.8-0.2,1.6-1,2.8-2.3 c0.7-0.7,2.2-2.5,3.9-4.8c-4.8,0.6-5.6,0.7-6.2,1c-0.1-0.5-0.5-1.7-0.8-2.3c0.7-0.1,1.3-0.9,2.1-2.1c0.9-1.2,3.7-5.6,5.4-9.8 l2.3,0.9c-1.8,3.8-4.1,7.6-6.3,10.6l5-0.4c0.8-1.2,1.6-2.5,2.4-3.7l2.1,1.2c-2.5,3.9-5.5,7.8-8.4,10.9L14.4,81.1L14.4,81.1z M2,90 c3.1-0.5,7.8-1.5,12.3-2.4l0.2,2.2c-4.3,0.9-8.7,1.9-12,2.7L2,90L2,90z M33.7,89.8v2.3h-19v-2.3H23V68.3h-7.7V66H33v2.3h-7.6v21.5 H33.7L33.7,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.9,81.5c-0.8-1.2-2.7-3.4-4.1-5.1v17.9h-2.2V76.9c-1.5,4.3-3.7,8.5-5.8,11c-0.2-0.7-0.9-1.6-1.3-2.1 c2.7-2.9,5.4-8.4,6.7-13.4h-5.9v-2.2h6.3v-7.5h2.2v7.5h5.6v2.2h-5.6v1.4c1.2,1.1,4.7,4.8,5.6,5.8L50.9,81.5L50.9,81.5z M69.5,82.8 C66,88,59.9,92.1,53,94.5c-0.3-0.6-1-1.3-1.5-1.8c6.6-2.1,12.6-6.1,15.8-10.9C67.3,81.8,69.5,82.8,69.5,82.8z M66.7,63.9 c-3,3.6-7.7,7.1-12.1,9.2c-0.3-0.5-1.1-1.2-1.6-1.7c4.2-1.9,8.9-5.2,11.5-8.5L66.7,63.9L66.7,63.9z M68,73.2 c-3.1,4-8.2,7.7-13.1,10c-0.4-0.6-1-1.4-1.6-1.8c4.7-2,9.8-5.5,12.5-9.2C65.8,72.2,68,73.2,68,73.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequoiaCapital);
export default __webpack_public_path__ + "static/media/sequoia-capital.668b9ca49408d834c2b98bbdfdf8e29c.svg";
export { ForwardRef as ReactComponent };